import type { SearchScenarioId } from "owa-search-store";
import { action } from "satcheljs";

/**
 * Action for initializing the refiners store for the given search scenario
 */
export interface INITIALIZE_REFINERS_SCENARIO_STOREActionMessage {
    scenarioId: SearchScenarioId;
}
export const initializeRefinersScenarioStore: (scenarioId: SearchScenarioId) => INITIALIZE_REFINERS_SCENARIO_STOREActionMessage = action("INITIALIZE_REFINERS_SCENARIO_STORE", (scenarioId: SearchScenarioId): INITIALIZE_REFINERS_SCENARIO_STOREActionMessage => ({
    scenarioId,
}));
